export default ($resource) => {
    const url = `${SEED_CORE.ENV.API_URL}company/audit-log/:id`;

    return $resource(url, null, {});
};



// WEBPACK FOOTER //
// ./src/app/resources/AuditLog/index.js